import { DELETE_ENTRY_STRATEGY, DELETE_ENTRY_STRATEGY_FAILED, DELETE_ENTRY_STRATEGY_SUCCESSFUL } from './actionTypes';

const initialState = {
  errorDeleteEntryStrategy: '',
  loadingDeleteEntryStrategy: false,
  successDeleteEntryStrategy: '',
};

const deleteEntryStrategy = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ENTRY_STRATEGY:
      state = {
        ...state,
        loadingDeleteEntryStrategy: true,
      };
      break;
    case DELETE_ENTRY_STRATEGY_SUCCESSFUL:
      state = {
        ...state,
        loadingDeleteEntryStrategy: false,
        successDeleteEntryStrategy: action.payload.message,
      };
      break;
    case DELETE_ENTRY_STRATEGY_FAILED:
      state = {
        ...state,
        errorDeleteEntryStrategy: action.payload,
        loadingDeleteEntryStrategy: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteEntryStrategy;
